import type { JSX } from "react";

import { Route, Routes } from "react-router-dom";

import MissingInformationRecord from "./MissingInformationRecord";
import MissingInformationRecords from "./MissingInformationRecords";

function MissingInformationRoutes(): JSX.Element {
    return (
        <Routes>
            <Route path=":recordId" element={<MissingInformationRecord />} />
            <Route index element={<MissingInformationRecords />} />
        </Routes>
    );
}

export default MissingInformationRoutes;
